import React from "react";
import SealCheck from "../../../assets/SealCheck.svg";
import "./Tab-bar.css";

// shows a completion check if done, and renders a progress bar for the current tab
export const TabBar = ({
  activeTab,
  setActiveTab,
  completedTabs,
  domainProgress,
}) => {
  // List of all assessment domains
  const tabs = [
    "Physical",
    "Emotional",
    "Acceptance",
    "Relationships",
    "Loving Kindness",
    "Intellectual",
  ];

  return (
    <div className="tab-bar">
      {tabs.map((tab, index) => {
        const normTab = tab.toLowerCase().replace(/[_-]/g, " ");
        const normActive = (activeTab || "").toLowerCase().replace(/[_-]/g, " ");
        const isActive = normTab === normActive;
        const isCompleted = completedTabs
          ? completedTabs.some((t) => (t || "").toLowerCase().replace(/[_-]/g, " ") === normTab)
          : false;

        const currentDomainProgress =
          domainProgress && (domainProgress[normTab] || domainProgress[tab.toLowerCase()])
            ? (domainProgress[normTab] || domainProgress[tab.toLowerCase()])
            : 0;

        return (
          <React.Fragment key={tab}>
            <div
              className={`tab-item ${isActive ? "active" : ""} ${
                isCompleted ? "iscompleted" : ""
              }`}
            >
              {isCompleted && (
                <img
                  src={SealCheck}
                  alt="Completed"
                  className="check-icon-inline"
                />
              )}
              <span>{tab}</span>
            </div>
            {isActive && index < tabs.length - 1 && (
              <div className="task-progress-container">
                <div
                  className="task-progress-bar"
                  style={{ width: `${currentDomainProgress}%` }}
                />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
